export enum TabEnum {
  // EcommerceAndSocialMedia = 'ecommerce_and_social_media',
  MarketplaceAndSocialMedia = 'marketplace_and_social_media',
  Website = 'website',
}

export enum RouteKey {
  Marketplace = 'marketplace',
  SocialMedia = 'social-media',
  WebsiteContent = 'website-content',
  DomainNames = 'domain-names',
  Seller = 'seller',
  ConversationalAssistant = 'conversational-assistant',
}

export enum SubTabKey {
  Detection = 'detection',
  UnderReview = 'under-review',
  ReportSubmitted = 'report-submitted',
  SoftNotice = 'soft-notice',
  NotEnforceable = 'not-enforceable',
  OnHold = 'on-hold',
  Archived = 'archived',
  ReviewNeeded = 'review-needed',
  Detected = 'detected',
  Requested = 'requested',
  Reported = 'reported',
  Removed = 'removed',
  Denied = 'denied',
  Dismissed = 'dismissed',
}

type ChannelMap = Record<RouteKey, string>;
type SubTabMap = Record<SubTabKey, string>;

export const amplitudeChannelMap: ChannelMap = {
  [RouteKey.Marketplace]: 'marketplace',
  [RouteKey.SocialMedia]: 'social media',
  [RouteKey.WebsiteContent]: 'website content',
  [RouteKey.DomainNames]: 'domain names',
  [RouteKey.Seller]: 'seller analytics',
  [RouteKey.ConversationalAssistant]: 'conversational assistant',
};

export const amplitudeSubTabMap: SubTabMap = {
  [SubTabKey.Detection]: 'Detection',
  [SubTabKey.Detected]: 'Detected',
  [SubTabKey.UnderReview]: 'Under review',
  [SubTabKey.ReportSubmitted]: 'Report submitted',
  [SubTabKey.SoftNotice]: 'Soft notice',
  [SubTabKey.NotEnforceable]: 'Not enforceable',
  [SubTabKey.OnHold]: 'On hold',
  [SubTabKey.Archived]: 'Archived',
  [SubTabKey.ReviewNeeded]: 'Review needed',
  [SubTabKey.Requested]: 'Requested',
  [SubTabKey.Reported]: 'Reported',
  [SubTabKey.Removed]: 'Removed',
  [SubTabKey.Denied]: 'Denied',
  [SubTabKey.Dismissed]: 'Dismissed',
};

export type ProfileRequestGrowthBookConfig = {
  production: number[];
  development: number[];
};
